import React from "react"
import { MDXProvider } from "@mdx-js/react"

import * as bridgeComponents from "../../../index"
import customElements from "../../custom-markdown-components"
import * as MdComponents from "./"

const {
  Link,
  List,
  Code,
  InlineCode,
  Table,
  Image,
  Paragraph,
  HorizontalRule,
  Blockquote,
  DescriptionList,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
} = MdComponents

const components = {
  a: Link,
  pre: props => props.children,
  code: Code,
  inlineCode: InlineCode,
  table: Table,
  img: Image,
  p: Paragraph,
  hr: HorizontalRule,
  blockquote: Blockquote,
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
  ul: List,
  ol: List.withComponent("ol"),
  dl: DescriptionList,

  ...bridgeComponents,

  ...customElements,
}

function wrapRootElement({ element }) {
  return <MDXProvider components={components}>{element}</MDXProvider>
}

export default wrapRootElement
